import { makeTheme } from '../make/makeTheme';
export var defaultTheme = makeTheme();